<template>
    <div id="post-block-wrapper">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'PostBlockWrapper',
        data() {
            return {

            }
        },
        components: {

        }
    }
</script>

<style lang="scss">
    #post-block-wrapper {
        .w-fan-page {
            margin-top: 40px;
        }
    }
</style>